module.exports = __webpack_public_path__ + "static/img/exit.b43cc50e.svg";